export const SAVE_SEARCH_NAME_MAX_LEN = 100;
export const SAVE_SEARCH_DESCRIPTION_MAX_LEN = 500;

export const DUPLICATE_SEARCH_ERROR_MSG =
  'Name already in use for at least one selected user. Pick another name';

export const SUPPORTER_LIST_NAME_MAX_LEN = 100;

export const SEARCH_TEMPLATE_NAME_MAX_LEN = 100;
export const SEARCH_TEMPLATE_DESCRIPTION_MAX_LEN = 500;
